module.exports = __webpack_public_path__ + "static/media/HOMEPAGE_2.4a5a87cf.jpg";